import { withStore } from 'store';
import { withLayout } from 'hocs';
import { useWindowSize } from 'hooks';
import MyGuestsExcelLanding  from './MyGuestsExcelLanding';

const MyGuestAddWeb = withLayout(withStore(
  {
    mapStateToProps: (state) => ({
      tableInfo: state.giftTable.giftTable
    }),
  }
)(MyGuestsExcelLanding));

const MyGuestAddMobile = withStore(
  {
    mapStateToProps: (state) => ({
      tableInfo: state.giftTable.giftTable
    }),
  }
)(MyGuestsExcelLanding);

function MyGuestsExcel() {
  const [, { isMobile }] = useWindowSize();

  return (
    <div>
      {isMobile ? (
        <MyGuestAddMobile />
      ) : (
        <MyGuestAddWeb />
      )}
    </div>
  );
}

export default MyGuestsExcel;


